import axios from 'axios'
import qs from 'qs'
import store from '@/store'
let isQa = /^(test|qa)-|10/.test(location.hostname);
let axiosbaseURL = `//vip${isQa ? 'test' : ''}-api.${process.env.VUE_APP_PAY_API}`
// let axiosbaseURL = '//103.38.227.170:20020/member-service'
const instance = axios.create({
  // 创建axios实例，在这里可以设置请求的默认配置  创建一个新的axios实例
  baseURL: axiosbaseURL,
  timeout: 10000 // 设置超时时间10s
})
// 文档统一设置post请求头。(post请求一般才需要设置)
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

/** 添加请求拦截器 **/
instance.interceptors.request.use(
  config => {
    store.commit('changeLoadPop', true)
    if (config.isToken) {
      config.headers.accessToken = localStorage.getItem('accessToken')
    }
    if (config.method === 'get') {
      // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
      config.params = {
        ...config.params
        // t: new Date().getTime()
      }
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 统一封装get请求
export const get = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'get',
      url,
      params,
      headers: {
        'Content-Type': 'application/json',
        'reqTs': new Date().getTime(),
        'appKey': store.state.currentGameAppkey,
        'token': localStorage.getItem('zlVipSid'),
        ...config
      }
    })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

// 统一封装post请求
export const post = (url, data, config = {}) => {
  if (config.func != 'MP') {
    if (!localStorage.getItem('zlVipSid')) {//支付中心、会员中心、客服中心登录状态传递时，防止信息错误，清除本地sid，需要重新获取
      let baseUrl = window.location.href.split('?')[0].split('#')[0];
      window.location.href = baseUrl
    }
  }
  // data = qs.stringify(data)
  //用户登录状态分两种，一种是用户未注册当前游戏，另一种是用户已注册当前游戏(分为有角色和无角色) 无角色可兑换游戏账户唯独下的优惠券
  //用户切换游戏，需重新获取用户游戏信息
  //用户所选项目，未在该项目下注册账户(account返回的userlist中不存在当前项目)，则默认传用户第一个项目的账户信息
  let index = JSON.parse(localStorage.getItem('zlVipUserList')).findIndex(item => item.appkey == store.state.currentGameAppkey)
  index = (index == -1 ? 0 : index)
  data = {
    accId: localStorage.getItem('zlVipAccountId'),
    uid: JSON.parse(localStorage.getItem('zlVipUserList'))[index].userid.toString(),
    did: JSON.parse(localStorage.getItem('zlVipUserList'))[index].device,
    tid: JSON.parse(localStorage.getItem('zlVipUserList'))[index].token,
    appKey: JSON.parse(localStorage.getItem('zlVipUserList'))[index].appkey.toString(),
    ...data
  }
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/json',
        'reqTs': new Date().getTime(),
        'appKey': store.state.currentGameAppkey,
        'token': config.func == 'MP' ? '' : localStorage.getItem('zlVipSid'),
        ...config
      }
    })
      .then(response => {
        store.commit('changeLoadPop', false)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/** 未登录请求 */
export const postNL = (url, data, config = {}) => {
  return new Promise((resolve, reject) => {
    instance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-Type': 'application/json',
        'reqTs': new Date().getTime(),
        'appKey': store.state.currentGameAppkey,
        'token': 'zlongametoken_nologin',
        ...config
      }
    })
      .then(response => {
        store.commit('changeLoadPop', false)
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}
